module.exports = __webpack_public_path__ + "static/media/nc.d393b8fa.svg";